import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { catchError, filter, map, of, switchMap, withLatestFrom } from 'rxjs';
import { StatementsApiService } from '../statements-api.service';
import * as fromStatementsActions from './statements.actions';
import { getStatementCategories } from './statements.selectors';

@Injectable()
export class StateStatementsEffects {
	constructor(
		private readonly _actions$: Actions,
		private _store: Store,
		private _stmtSrv: StatementsApiService,
	) {}

	fetchCategories = createEffect(() =>
		this._actions$.pipe(
			ofType(fromStatementsActions.fetchStatementCategories),
			withLatestFrom(this._store.select(getStatementCategories)),
			filter(([, categories]) => !categories),
			switchMap(() =>
				this._stmtSrv.getAllCategories().pipe(
					map((categories) => {
						return fromStatementsActions.updateStatementCategories({
							categories,
						});
					}),
					catchError((error) =>
						of(fromStatementsActions.loadStatementsFailure(error)),
					),
				),
			),
		),
	);

	fetchStatementsByCategory = createEffect(() =>
		this._actions$.pipe(
			ofType(fromStatementsActions.fetchStatementsByCategory),
			switchMap((params) =>
				this._stmtSrv.getStatementsByCategory(params.categorySlug).pipe(
					map((statements) => {
						return fromStatementsActions.updateStatementsForCategory({
							statements: statements,
							categorySlug: params.categorySlug,
						});
					}),
					catchError((error) =>
						of(fromStatementsActions.loadStatementsFailure(error)),
					),
				),
			),
		),
	);

	fetchStatementArticle = createEffect(() =>
		this._actions$.pipe(
			ofType(fromStatementsActions.fetchStatementArticle),
			switchMap((params) =>
				this._stmtSrv
					.getStatementArticle(params.categorySlug, params.statementUrl)
					.pipe(
						map((statement) => {
							return fromStatementsActions.updateStatementArticle({
								statement,
							});
						}),
						catchError((error) =>
							of(fromStatementsActions.loadStatementsFailure(error)),
						),
					),
			),
		),
	);
}
